import useMedia from 'shared/hooks/useMedia';

export const useMobile = () => {
  return useMedia('(max-width: 768px)');
};
